import { ComponentPropsWithRef } from "react";

export const FileMp3Icon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M0.799805 15.8V1.8C0.799805 1.24771 1.24752 0.799999 1.7998 0.799999H8.8858C9.15084 0.800056 9.40501 0.90532 9.59247 1.09267L13.5071 5.00733C13.6945 5.1948 13.7997 5.44897 13.7998 5.714V8.8"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7998 5.8H9.7998C9.24752 5.8 8.7998 5.35228 8.7998 4.8V0.799999"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.7998 15.8V10.8L4.2998 13.3L2.7998 10.8V15.8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.7998 15.8V10.8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.7998 10.8H8.2998C9.12823 10.8 9.7998 11.4716 9.7998 12.3C9.7998 13.1284 9.12823 13.8 8.2998 13.8H7.7998"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7998 11.8C11.7998 11.2477 12.2475 10.8 12.7998 10.8L13.5565 10.8033C14.2347 10.8204 14.7752 11.3758 14.7737 12.0543C14.7723 12.7327 14.2294 13.2858 13.5511 13.3C14.2294 13.3142 14.7723 13.8673 14.7737 14.5457C14.7752 15.2242 14.2347 15.7796 13.5565 15.7967H12.7998C12.2475 15.7967 11.7998 15.349 11.7998 14.7967"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
